import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MATERIAL,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TENCENT_RETEXTURE_PRO,
  "provider": PROVIDER.TENCENT,
  "action": ACTION.RETEXTURE,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
      },
      "prompt": {
        "type": "string",
        "minLength": 1,
        "maxLength": 1024,
      },
      "enable_pbr": {
        "type": "boolean",
        "default": false,
      },
    },
    "required": ["input_3d"],
    "allOf": [
      {
        "if": {
          "properties": {
            "prompt": { "const": "" },
          },
          "required": ["prompt"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": {
            "material": { "enum": [MATERIAL.BASIC, MATERIAL.PBR] },
          },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["enable_pbr"],
        },
        "then": {
          "properties": {
            "enable_pbr": { "const": true },
          },
        },
      },
    ],
  },
  "ui_schema": {},
}
